module.exports={
	"Scope": "DocumentApprovalState-List",
	"CoreEntity": "DocumentApprovalState",
	"TitleTemplate": "Document Approval States",
	"Descriptors":
	{
		"Name":
		{
			"Name": "State Name",
			"Hash": "DocStateListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateListHash",
			"PictDashboard": {}
		}
	}
}
